const types = {
  CLEAR_CURRENT: 'BENEFITS_CLEAR_CURRENT',
  GET_REQUEST: 'BENEFITS_GET_REQUEST',
  GET_SUCCESS: 'BENEFITS_GET_SUCCESS',
  GET_FAILURE: 'BENEFITS_GET_FAILURE',

  SAVE_REQUEST: 'BENEFITS_SAVER_REQUEST',
  SAVE_SUCCESS: 'BENEFITS_SAVE_SUCCESS',
  SAVE_FAILURE: 'BENEFITS_SAVE_FAILURE',

  GETALL_REQUEST: 'BENEFITS_GETALL_REQUEST',
  GETALL_SUCCESS: 'BENEFITS_GETALL_SUCCESS',
  GETALL_FAILURE: 'BENEFITS_GETALL_FAILURE',

  DELETE_REQUEST: 'BENEFITS_DELETE_REQUEST',
  DELETE_SUCCESS: 'BENEFITS_DELETE_SUCCESS',
  DELETE_FAILURE: 'BENEFITS_DELETE_FAILURE',    

  UPDATE_REQUEST: 'BENEFITS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'BENEFITS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'BENEFITS_UPDATE_FAILURE'    

};

export default types